export default "__VITE_ASSET__CWZ1Xnz0__"